import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import * as index from './logos/index.js';
import { propTypes, defaultProps } from './WordLogo.types.js';

/**
 * A WordLogo component
 *
 * Displays a BrandLogo component
 */
var WordLogo = /** @class */ (function (_super) {
    __extends(WordLogo, _super);
    function WordLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordLogo.prototype.render = function () {
        var _a = this.props, variant = _a.variant, logoProps = __rest(_a, ["variant"]);
        var logoSet = index;
        // Get the icon
        var BrandLogo = logoSet[variant + "BrandLogo"];
        if (!BrandLogo) {
            console.warn("[WordLogo Component] No logo with variant: " + variant + " defined");
            return React__default.createElement("div", null);
        }
        return React__default.createElement(BrandLogo, __assign({}, logoProps));
    };
    WordLogo.displayName = 'WordLogo';
    WordLogo.propTypes = propTypes;
    WordLogo.defaultProps = __assign({}, defaultProps);
    return WordLogo;
}(React__default.Component));

export { WordLogo as default };
